import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Grid } from "@mui/material";

const ClientDetailsDialog = ({ open, onClose, client }) => {
  if (!client) {
    return (
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>بيانات العميل</DialogTitle>
        <DialogContent>
          <Typography color="text.secondary">لا توجد بيانات للعميل</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>إغلاق</Button>
        </DialogActions>
      </Dialog>
    );
  }

  const formatDate = (v) => {
    if (!v) return "-";
    const d = new Date(v);
    if (Number.isNaN(d.getTime())) return v;
    return d.toLocaleString(undefined, { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>بيانات العميل — {client.id || "-"}</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="subtitle2">الاسم</Typography>
            <Typography>{client.name || client.email || "-"}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2">البريد الإلكتروني</Typography>
            <Typography>{client.email || "-"}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2">الهاتف</Typography>
            <Typography>{client.phone || "-"}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2">العنوان</Typography>
            <Typography>{client.address || "-"}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2">الحالة</Typography>
            <Typography>{client.status ?? "-"}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2">تاريخ الإنشاء</Typography>
            <Typography>{formatDate(client.created_at)}</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>إغلاق</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClientDetailsDialog;
